import dispatcher from "../dispatcher";
import { shiftConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createShift(shift) {
    rq.postJson("/api/v1/shift", shift).then((data) => {
        shift.shiftId = data[0].lastId;
        dispatcher.dispatch({ type: shiftConstant.SHIFT_CREATED, shift });
    }).catch((err) => {
        if (err.msg)
            dispatcher.dispatch({ type: shiftConstant.SHIFT_CREATION_FAILED, msg: err.msg });
        else
            dispatcher.dispatch({ type: shiftConstant.SHIFT_CREATION_FAILED, msg: `creating shift ${shift.shiftName} failed ! ` });
    });
}

export function fetchAllShift() {
    rq.getJsonData("/api/v1/shift").then((data) => {
        dispatcher.dispatch({ type: shiftConstant.FETCHED_ALL_SHIFT, data });
    }).catch(() => {
        dispatcher.dispatch({ type: shiftConstant.SHIFT_FETCH_FAILED, msg: "Fetching shift failed ! " });
    });
}


export function startNewShift(newShiftData) {
    rq.postJson("/api/v1/startnewshift", newShiftData).then(() => {
        dispatcher.dispatch({ type: shiftConstant.NEW_SHIFT_STARTED, msg: "Starting new shift" });
    }).catch((err) => {
        if (err.msg)
            dispatcher.dispatch({ type: shiftConstant.NEW_SHIFT_FAILED, msg: err.msg });
        else
            dispatcher.dispatch({ type: shiftConstant.NEW_SHIFT_FAILED, msg: "Starting new shift failed ! " });

    });
}




// WEBPACK FOOTER //
// ./src/jsx/actions/shift-action.jsx